import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//? -----------------To get data with validity in the quiz page--------------
export const getCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/get",
  async (data) => {
    // const { usertype } = params;
    let response = await api.get(
      `getMasterTtlQuizTopicsData/${data.usertype}/student/od/${data.program}/${data.clas}`
    );
    return response.data;
  }
);

//?---------------Creation of new topic with validity-------------------->
export const createCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/create",
  async (body) => {
    let response = await api.post("saveMasterTtlQuizTopic ", body);
    return response.data;
  }
);

//?----------------Updating the data in the quiz page (update icon)--------
export const updateCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateMasterTtlQuizTopic/" + id, body.body);
    return response.data;
  }
);

//?----------deleting the data from the quiz page----------------------
export const deleteCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/delete",
  async (data) => {
    let response = await api.delete(`deleteMasterTtlQuizTopic/${data.topicId}`);
    return response.data;
  }
);
